import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Box,
} from "@mui/material";
import { toast } from "react-toastify";
import apiClient from "../Utils/apiClient";

const REASONS = [
  { value: "fraud", label: "Fraud" },
  { value: "duplicate", label: "Duplicate" },
  { value: "user_request", label: "User Request" },
  { value: "other", label: "Other" },
];

export default function DeleteUserModal({ open, onClose, user, onUserDeleted }) {
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    if (!reason) {
      toast.warn("Please select a reason for deletion.");
      return;
    }

    const userId = user?.id || user?._id || user?.userId;
    if (!userId) {
      toast.error("User ID not found.");
      return;
    }

    try {
      setLoading(true);
      const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
      const adminId = localStorage.getItem("userId") || storedUser?._id || storedUser?.id || storedUser?.userId;

      await apiClient.post(`/admin/users/${userId}/delete`, {
        reason,
        deleted_by: adminId,
      });

      toast.success("User deleted successfully!");
      setReason("");
      onClose();
      if (onUserDeleted) {
        onUserDeleted();
      }
    } catch (error) {
      console.error("[DeleteUserModal] error:", error);
      const message = error?.message || (error?.code === 409 ? "User has an active trip or pending withdrawal." : "Failed to delete user.");
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  const displayName = user?.userName || user?.name || "User";
  const displayPhone = user?.userPhone || user?.phoneNumber || user?.phone || "—";

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: "bold" }}>Delete User Account</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 1, mb: 2 }}>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            Are you sure you want to delete this user?
          </Typography>
          <Box sx={{ my: 1.5, p: 1.5, bgcolor: "#f8f9fa", borderRadius: 1 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
              Name: <span style={{ fontWeight: 400 }}>{displayName}</span>
            </Typography>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, mt: 0.5 }}>
              Phone: <span style={{ fontWeight: 400 }}>{displayPhone}</span>
            </Typography>
          </Box>
          <FormControl fullWidth size="small" sx={{ mt: 2 }} required>
            <InputLabel id="delete-reason-label">Reason</InputLabel>
            <Select
              labelId="delete-reason-label"
              id="delete-reason-select"
              value={reason}
              label="Reason"
              onChange={(e) => setReason(e.target.value)}
            >
              {REASONS.map((r) => (
                <MenuItem key={r.value} value={r.value}>
                  {r.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={loading} color="inherit">
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          disabled={loading || !reason}
          variant="contained"
          sx={{
            backgroundColor: "#d32f2f !important",
            color: "#fff !important",
            "&:hover": { backgroundColor: "#b71c1c !important" },
          }}
        >
          {loading ? "Deleting..." : "Confirm Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
